import { useEffect } from "react";
import { useLocation } from "react-router-dom";

interface SitemapProps {
  type?: string;
}

const Sitemap = ({ type }: SitemapProps) => {
  const location = useLocation();

  useEffect(() => {
    const fetchAndServeSitemap = async () => {
      try {
        // Determina il tipo di sitemap dalla prop o dal path
        let sitemapType = type;
        
        if (!sitemapType) {
          const path = location.pathname;
          if (path === "/sitemap.xml" || path === "/sitemap") {
            sitemapType = undefined; // Index
          } else if (path.includes("page-sitemap")) {
            sitemapType = "page";
          } else if (path.includes("professional-sitemap")) {
            sitemapType = "professional";
          } else if (path.includes("company-sitemap")) {
            sitemapType = "company";
          } else if (path.includes("event-sitemap")) {
            sitemapType = "event";
          } else if (path.includes("category-sitemap")) {
            sitemapType = "category";
          }
        }

        // Costruisci URL della edge function
        const baseUrl = "https://ffisxgjejiyihehxodwo.supabase.co/functions/v1/generate-sitemap";
        const url = sitemapType ? `${baseUrl}?type=${sitemapType}` : baseUrl;

        console.log(`[Sitemap] Fetching: ${url}`);

        const response = await fetch(url, {
          headers: {
            "Accept": "application/xml, text/xml, */*"
          }
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const xml = await response.text();
        
        // Serve XML puro usando document.write
        // Questo mantiene l'URL su inclusia.pro ma serve XML che Google può leggere
        document.open("application/xml");
        document.write(xml);
        document.close();
        
      } catch (err) {
        console.error("[Sitemap] Error:", err);
        // In caso di errore, mostra un messaggio
        document.open("text/html");
        document.write(`
          <!DOCTYPE html>
          <html>
          <head><title>Sitemap Error</title></head>
          <body style="font-family: system-ui; padding: 40px; text-align: center;">
            <h1>Errore Sitemap</h1>
            <p>${err instanceof Error ? err.message : "Errore nel caricamento"}</p>
          </body>
          </html>
        `);
        document.close();
      }
    };

    fetchAndServeSitemap();
  }, [type, location.pathname]);

  // Non renderizza nulla - document.write sovrascrive tutto
  return null;
};

export default Sitemap;
